import { render, staticRenderFns } from "./sidebar-edit-empty.vue?vue&type=template&id=0e33ad12&"
import script from "./sidebar-edit-empty.vue?vue&type=script&lang=ts&"
export * from "./sidebar-edit-empty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports